export const name = (user: { name: string, surname?: string }) => {

  if (!user.name || !user.surname) return user.name || user.surname || ""
  return user.name + " " + user.surname
}